import styled from 'styled-components';

import { AnimatedRouter as Router } from '../../../components/AnimatedRouter';
import { px } from '../../../contrib/ui';

export const FooterRouterStyled = styled(Router)`
  .router,
  .router > div > .staff-scope,
  .router > div > .home-scope,
  .router > div > .club-scope,
  .router > div > .event-scope,
  .router > div > .event-scores-scope {
    height: fit-content;
    min-height: fit-content;
  }

  .router > div > .event-scores-scope {
    padding-bottom: ${px(50)};
  }
`;
